module.exports = __webpack_public_path__ + "img/rugs-and-runners.0360f33.png";